import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

export type BreadcrumbItem = {
  label: string;
  to: string;
};

export interface PlatformBreadcrumbsProps {
  /** Additional breadcrumb items between "Platform Policies" and the current page */
  items?: BreadcrumbItem[];
  /** Current page title (not a link) */
  currentPage: string;
  /** Whether to show the "Platform Policies" link. Default: true */
  showPlatformPolicies?: boolean;
}

export function PlatformBreadcrumbs({
  items = [],
  currentPage,
  showPlatformPolicies = true,
}: PlatformBreadcrumbsProps) {
  return (
    <Breadcrumbs
      sx={{ mb: 3, overflowWrap: "anywhere" }}
      separator="›"
      aria-label="Breadcrumbs"
    >
      <Link component={RouterLink} to="/dashboard" display="flex">
        <HomeIcon fontSize="inherit" />
      </Link>
      {showPlatformPolicies && (
        <Link component={RouterLink} to="/policies">
          Platform Policies
        </Link>
      )}
      {items.map((item, index) => (
        <Link key={index} component={RouterLink} to={item.to}>
          {item.label}
        </Link>
      ))}
      <Typography>{currentPage}</Typography>
    </Breadcrumbs>
  );
}
